import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/database';
import { logError, logInfo } from '../utils/logger';

export const useVersion = () => {
  const [version, setVersion] = useState('3.0');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const versionRef = doc(db, 'system', 'version');
    
    const unsubscribe = onSnapshot(versionRef, 
      (snapshot) => {
        if (snapshot.exists()) {
          setVersion(snapshot.data().current);
          logInfo('Version loaded successfully');
        }
        setLoading(false);
      },
      (error) => {
        logError('Error fetching version:', error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  return { version, loading };
};